"use strict";
/**
 * @description 入口文件
 * @author wangfupeng
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./assets/style/common.less");
require("./assets/style/icon.less");
require("./assets/style/menus.less");
require("./assets/style/text.less");
require("./assets/style/panel.less");
require("./assets/style/droplist.less");
require("./utils/polyfill");
var index_1 = __importDefault(require("./editor/index"));
__exportStar(require("./menus/menu-constructors/index"), exports);
// 检验是否浏览器环境
try {
    document;
}
catch (ex) {
    throw new Error('请在浏览器环境下运行');
}
exports.default = index_1.default;
